import { apiSlice as api } from '../../../../apiSlice';
export const addTagTypes = ['Data', 'DataTypes', 'Units'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      dataGetCollectionAsyncByqueryOptions: build.query<
        DataGetCollectionAsyncByqueryOptionsApiResponse,
        DataGetCollectionAsyncByqueryOptionsApiArg
      >({
        query: (queryArg) => ({
          url: `/Data`,
          params: {
            orderby: queryArg.orderby,
            orderbydesc: queryArg.orderbydesc,
            Timestamp: queryArg.timestamp,
            UnitId: queryArg.unitId,
            AggregateType: queryArg.aggregateType,
            DataType: queryArg.dataType,
            UnitTypeInputId: queryArg.unitTypeInputId,
            top: queryArg.top,
            skip: queryArg.skip,
          },
        }),
        providesTags: ['Data'],
      }),
      dataPostAsyncBydata: build.mutation<
        DataPostAsyncBydataApiResponse,
        DataPostAsyncBydataApiArg
      >({
        query: (queryArg) => ({
          url: `/Data`,
          method: 'POST',
          body: queryArg.body,
        }),
        invalidatesTags: ['Data'],
      }),
      dataTypesGetCollection: build.query<
        DataTypesGetCollectionApiResponse,
        DataTypesGetCollectionApiArg
      >({
        query: () => ({ url: `/DataTypes` }),
        providesTags: ['DataTypes'],
      }),
      unitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataType:
        build.mutation<
          UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiResponse,
          UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiArg
        >({
          query: (queryArg) => ({
            url: `/Units/${queryArg.unitId}/AlarmConfiguration/${queryArg.key}/${queryArg.unitTypeInputId}/${queryArg.dataType}`,
            method: 'PUT',
            params: {
              value: queryArg.value,
            },
          }),
          invalidatesTags: ['Units'],
        }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as recalcOpenApi };
export type DataGetCollectionAsyncByqueryOptionsApiResponse =
  /** status 200 Data entities response */ ReadData2Dto[];
export type DataGetCollectionAsyncByqueryOptionsApiArg = {
  /** <p><a href='#queryoptions'>Sorts</a> the result in ascending order by the supplied property.</p><p>Valid values are: <strong>Timestamp</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderby?: string;
  /** <p><a href='#queryoptions'>Sorts</a> the result in descending order by the supplied property.</p><p>Valid values are: <strong>Timestamp</strong> (default).</p><p>Note: <strong>orderby</strong> and <strong>orderbydesc</strong> are mutually exclusive.</p> */
  orderbydesc?: string;
  /** <p><a href="#queryoptions">Filters</a> the result by Timestamp using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(datetime)</code>
    Greater than or equal:
    <code>ge(datetime)</code>
    Greater than:
    <code>gt(datetime)</code>
    Less than or equal:
    <code>le(datetime)</code>
    Less than:
    <code>lt(datetime)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(2021-01-01T16:00:00.0000000+02:00)</code>
    Greater than or equal:
    <code>ge(2021-01-01T16:00:00.0000000+02:00)</code>
    Greater than:
    <code>gt(2021-01-01T16:00:00.0000000+02:00)</code>
    Less than or equal:
    <code>le(2021-01-02T16:00:00.0000000+02:00)</code>
    Less than:
    <code>lt(2021-01-02T16:00:00.0000000+02:00)</code></pre></div> */
  timestamp: string[];
  /** <p><a href="#queryoptions">Filters</a> the result by UnitId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div> */
  unitId: string;
  /** <p><a href="#queryoptions">Filters</a> the result by AggregateType using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(aggregatetype)</code></pre></div><p>aggregatetype = ['Raw', 'Minutes5', 'Hour', 'Day']</p><p>Examples:</p><div><pre>Equal to:
    <code>eq(Minutes5)</code></pre></div> */
  aggregateType: string;
  /** <p><a href="#queryoptions">Filters</a> the result by DataType using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(datatype)</code></pre></div><p>datatype = ['power', 'power-consumption', 'accumulated-power', 'current', 'accumulated-current', 'voltage', 'grid-frequency', 'temperature', 'flow', 'flow-normalized', 'flow-consumption', 'flow-consumption-normalized', 'accumulated-flow', 'accumulated-flow-normalized', 'heat', 'heat-consumption', 'accumulated-heat', 'uncalibrated-current', 'time-consumption', 'indicative-consumption', 'standby-consumption', 'apparent-power', 'co2-concentration', 'humidity', 'analog-voltage', 'analog-current', 'ph', 'volume', 'mass-concentration', 'power-factor', 'weight', 'quantity', 'percent', 'custom', 'presence', 'unknown', 'flow-speed', 'single-coil-current', 'motor-frequency', 'motor-frequency-score', 'uncalibrated-flow-speed', 'pressure', 'Length', 'Radon-level-Bq', 'Radon-level-pCi', 'voc', 'uncalibrated-accumulated-flow', 'air-flow']</p><p>Examples:</p><div><pre>Equal to:
    <code>eq(power)</code></pre></div> */
  dataType: string;
  /** <p><a href="#queryoptions">Filters</a> the result by UnitTypeInputId using the supplied operation and value.</p><p>Valid operations are: </p><div><pre>Equal to:
    <code>eq(int)</code><code>eq(null)</code></pre></div><p>Examples:</p><div><pre>Equal to:
    <code>eq(3001)</code></pre></div><p>Data is either associated with a unit or a specific unit part (UnitTypeInputId).
                Use the filters eq(null) or eq(int) to query them respectively.
                Get the UnitTypeInputId by either /Units/{id} if you know the UnitId or /UnitTypes/{id} if you know the UnitTypeId.</p> */
  unitTypeInputId: string;
  /** <a href="#queryoptions">Query paging</a> Returns the maximum number of entities. Default and max value is 10000 */
  top?: number;
  /** <a href="#queryoptions">Query paging</a> Skips this number of entities */
  skip?: number;
};
export type DataPostAsyncBydataApiResponse = /** status 201 Created */ object;
export type DataPostAsyncBydataApiArg = {
  /** Collection of data points to insert */
  body: CreateDataDto[];
};
export type DataTypesGetCollectionApiResponse =
  /** status 200 user entities response */ ReadDataTypeDto[];
export type DataTypesGetCollectionApiArg = void;
export type UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiResponse =
  /** status 204 No content */ object;
export type UnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeApiArg =
  {
    /** The id of the Unit */
    unitId: number;
    /** The unitTypeInputIdt */
    unitTypeInputId: number;
    /** Configuration key */
    key: string;
    /** Configuration value */
    value?: string;
    /** Configuration dataType (optional) */
    dataType: string;
  };
export type ReadData2Dto = {
  UnitId: number;
  DataType:
    | 'power'
    | 'power-consumption'
    | 'accumulated-power'
    | 'current'
    | 'accumulated-current'
    | 'voltage'
    | 'grid-frequency'
    | 'temperature'
    | 'flow'
    | 'flow-normalized'
    | 'flow-consumption'
    | 'flow-consumption-normalized'
    | 'accumulated-flow'
    | 'accumulated-flow-normalized'
    | 'heat'
    | 'heat-consumption'
    | 'accumulated-heat'
    | 'uncalibrated-current'
    | 'time-consumption'
    | 'indicative-consumption'
    | 'standby-consumption'
    | 'apparent-power'
    | 'co2-concentration'
    | 'humidity'
    | 'analog-voltage'
    | 'analog-current'
    | 'ph'
    | 'volume'
    | 'mass-concentration'
    | 'power-factor'
    | 'weight'
    | 'quantity'
    | 'percent'
    | 'custom'
    | 'presence'
    | 'unknown'
    | 'flow-speed'
    | 'single-coil-current'
    | 'motor-frequency'
    | 'motor-frequency-score'
    | 'uncalibrated-flow-speed'
    | 'pressure'
    | 'Length'
    | 'Radon-level-Bq'
    | 'Radon-level-pCi'
    | 'voc'
    | 'uncalibrated-accumulated-flow'
    | 'air-flow';
  AggregateType: 'Raw' | 'Minutes5' | 'Hour' | 'Day';
  UnitTypeInputId?: number;
  Timestamp: string;
  Value?: number;
  Base?: string;
};
export type ErrorResult = {
  Code: string;
  Message: string;
};
export type BadRequestError = {
  Code: string;
  Message: string;
};
export type PropertyValueError = {
  Property: string;
  Code: string;
  Message: string;
};
export type ArrayProperty = {
  Property?: ArrayProperty;
  Name: string;
  Index?: number;
};
export type ArrayPropertyValueError = {
  Property: ArrayProperty;
  Code: string;
  Message: string;
};
export type ErrorDetailsResult2 = ErrorResult & {
  BadRequestErrors?: BadRequestError[];
  PropertyValueErrors?: PropertyValueError[];
  ArrayPropertyValueErrors?: ArrayPropertyValueError[];
};
export type ErrorDetailsResult = ErrorDetailsResult2;
export type ErrorResult2 = ErrorResult;
export type ErrorResult3 = ErrorResult;
export type CreateDataDto = {
  UnitId: number;
  UnitTypeInputId?: number;
  AggregateType: 'Raw' | 'Minutes5' | 'Hour' | 'Day';
  DataType:
    | 'power'
    | 'power-consumption'
    | 'accumulated-power'
    | 'current'
    | 'accumulated-current'
    | 'voltage'
    | 'grid-frequency'
    | 'temperature'
    | 'flow'
    | 'flow-normalized'
    | 'flow-consumption'
    | 'flow-consumption-normalized'
    | 'accumulated-flow'
    | 'accumulated-flow-normalized'
    | 'heat'
    | 'heat-consumption'
    | 'accumulated-heat'
    | 'uncalibrated-current'
    | 'time-consumption'
    | 'indicative-consumption'
    | 'standby-consumption'
    | 'apparent-power'
    | 'co2-concentration'
    | 'humidity'
    | 'analog-voltage'
    | 'analog-current'
    | 'ph'
    | 'volume'
    | 'mass-concentration'
    | 'power-factor'
    | 'weight'
    | 'quantity'
    | 'percent'
    | 'custom'
    | 'presence'
    | 'unknown'
    | 'flow-speed'
    | 'single-coil-current'
    | 'motor-frequency'
    | 'motor-frequency-score'
    | 'uncalibrated-flow-speed'
    | 'pressure'
    | 'Length'
    | 'Radon-level-Bq'
    | 'Radon-level-pCi'
    | 'voc'
    | 'uncalibrated-accumulated-flow'
    | 'air-flow';
  Timestamp: string;
  Value?: number;
};
export type ReadDataTypeDto = {
  Key: string;
  Aggregations?: ('Raw' | 'Minutes5' | 'Hour' | 'Day')[];
  ProduceableSensors?: string[];
  Base?: string;
  AccumulationType:
    | 'Accumulated'
    | 'Consumption'
    | 'ConsumptionPoint'
    | 'Point';
};
export type ErrorResult4 = ErrorResult;
export const {
  useDataGetCollectionAsyncByqueryOptionsQuery,
  useLazyDataGetCollectionAsyncByqueryOptionsQuery,
  useDataPostAsyncBydataMutation,
  useDataTypesGetCollectionQuery,
  useLazyDataTypesGetCollectionQuery,
  useUnitsAlarmConfigurationAsyncByunitIdunitTypeInputIdkeyvaluedataTypeMutation,
} = injectedRtkApi;
